import React from 'react';

const StructuredData = ({ type = "Person", data = {} }) => {
  const defaultPersonData = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Gianluca Gatto",
    "jobTitle": "3D Artist & Blender Specialist",
    "description": "3D artist making photorealistic environments and game-ready props in Blender — shopfronts, vending machines, signage and street furniture.",
    "url": "https://gattogianluca.com/",
    "sameAs": [
      "https://www.youtube.com/@Gianluca3D",
      "https://www.turbosquid.com/Search/Artists/GianlucaGatto",
      "https://www.cgtrader.com/designers/gianluca-gatto",
      "https://sketchfab.com/shockproof"
    ],
    "knowsAbout": [
      "3D Modeling", "Blender", "Environment Art",
      "Game Assets", "Product Visualization", "PBR Texturing"
    ]
  };

  const isPersonType = (data["@type"] || type) === "Person";
  const structuredData = isPersonType ? { ...defaultPersonData, ...data } : data;

  // Escape `<` so a CMS field containing `</script>` cannot break out of
  // the inline JSON-LD block (defense-in-depth — content is CMS-only).
  const safeJson = JSON.stringify(structuredData).replace(/</g, '\\u003c');

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: safeJson }}
    />
  );
};

export default StructuredData;
